import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { pricingActions } from "..";
import { RootState } from "@src/store/store";
import { EventInventoryRecord, getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

const initialState = false;
export interface IListingToUpdate {
	listingIds: Array<number>;
	discount: string;
}

export const { thunk: updateFlashSale, slice: updateFlashSaleSlice } = getThunkAndSlice<IListingToUpdate, typeof initialState>({
	initialState,
	path: "/api/Pricing/AddFlashSale",
	method: "post",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const eventId = getInventoryCacheEventId(rootState);
		const inventoryAllState = rootState.pricing.eventInventoryAll.data;
		const newData = inventoryAllState.map((x) => {
			return x.Listing_ID === params.listingIds[0] ? { ...x, FlashSaleEnabled: true, FlashSaleDiscount: +params.discount } : x;
		});

		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId }));

		if (rootState.pricing.globalInventory.data.length) {
			const newGlobalData = (rootState.pricing.globalInventory.data as Array<EventInventoryRecord>).map((x) => {
				return x.Listing_ID === params.listingIds[0]
					? { ...x, FlashSaleEnabled: true, FlashSaleDiscount: +params.discount }
					: x;
			});
			dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
		}

		return data;
	},
});
